import React from "react";
import Icons from "components/icons";
import Localize from "components/service/localize";
import "./user-status-badge.css";

const BEST_SALESMAN_AWARD_YEAR = 2026;

const UserStatusBadge = ({ diamondStatus = false, bestSalesman = false, variant = "compact" }) => {
    if (!bestSalesman && !diamondStatus) return null;

    const award = bestSalesman && variant === "award";
    const label = bestSalesman
        ? (award ? "GLOBAL.Text_TopSalesman" : "GLOBAL.Text_BestSalesman")
        : "GLOBAL.Text_DiamondStatus";

    return (
        <div className={`user-status-badge${award ? " user-status-badge--award" : ""}`}>
            <span>
                <Localize>{label}</Localize>
                {bestSalesman ? ` ${BEST_SALESMAN_AWARD_YEAR}` : null}
            </span>
            <span className="user-status-badge-icon" aria-hidden="true">
                {bestSalesman ? <Icons.BestSalesman /> : <Icons.Diamond />}
            </span>
        </div>
    );
};

export default UserStatusBadge;
